import { Injectable } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class FormService {
  constructor(private formBuilder: FormBuilder) { }
  editProfile: FormGroup = new FormBuilder().group({
    email: [''],
    name: [''],
    logline: [''],
    countryCode: ['+1'],
    phone: [''],
    faith: [''],
    communitytype: [''],
    address: [''],
    address2: [''],
    bridgenumber: [''],
    guitarstarid: [''],
    androidapplink: [''],
    iOSappLInk: [''],
    certificateno: [''],
    alternatecontactnumber: [''],
    publicemail: [''],
    countryofreg: [''],
    avgweeklyattendance: [''],
    communityUserName: [''],
    affiliatedBy: [''],
    associatedBy: [''],
    photo: [''],
    coverPhoto: [''],
    subfaithVal: [''],
    subfaithVal2: [''],
    subfaithBranch: [''],
    primaryAddress2: [''],
    secondaryAddress2: ['']
  });



  MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors['mustMatch']) {
        // return if another validator has already found an error on the matchingControl
        return;
      }
      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }
}
